export default __webpack_public_path__ + "static/media/Pangea_Images_Set_sails_30_x_40_cm.ed617c9a.jpg";